import { Directive, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '@app/services/loading.service';
import { SecurityService } from '@app/services/security.service';
import { TranslateService } from '@ngx-translate/core';
import { AbstractComponentMobile } from '@web/ui-mobile';
import { ToastService } from '../services/toast.service';

@Directive()
export abstract class AbstractPage extends AbstractComponentMobile implements OnDestroy {
    protected readonly router: Router = inject(Router);
    protected readonly toastService: ToastService = inject(ToastService);
    protected readonly loadingService: LoadingService = inject(LoadingService);
    protected readonly translateService: TranslateService = inject(TranslateService);
    protected securityService: SecurityService = inject(SecurityService);

    protected loaders: string[] = [];

    constructor() {
        super();
    }

    /**
     * Shows a loading indicator.
     * @param id - Optional unique identifier for the loader instance
     * @param fullHeight - If true, loader takes 100% height (ignoring safe area bottom). Use for full-page blocking operations during critical updates (e.g., device patches). Default: false
     * @param message - Optional custom message to display. If not provided, no message is shown (empty string)
     */
    public showLoader(id?: string, fullHeight = false, message?: string): void {
        if (id && this.loaders.includes(id) === false) {
            this.loaders.push(id);
        }

        this.loadingService.show(id, message || '', 0, fullHeight);
    }

    public hideLoader(id?: string): void {
        // Remove id from list of loaders ids, otherwise isLoaderActive method can’t work properly
        if (id) {
            const indexId = this.loaders.indexOf(id);
            this.loaders.splice(indexId, 1);
        }
        this.loadingService.hide(id);
    }

    public isLoaderActive(id: string) {
        return this.loaders.includes(id);
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();

        this.loadingService.hide();
    }

    override ionViewWillLeave(): void {
        super.ionViewWillLeave();

        for (const key of this.loaders) {
            this.loadingService.hide(key);
        }
    }

    public range(length: number): number[] {
        return Array.from({ length }, (_, i) => i);
    }
}
